const UsersStrings = {
    status: {
        active: "Активен",
        mute: "Замьючен",
        ban: "Забанен"
    }
}

export default UsersStrings;